<template>
  <div v-bind:class="[ 'sf-sticky__bar', stuck ? 'sf-sticky__bar--stuck' : null ]">
    <slot />
  </div>
</template>

<script>
  /**
   * Beim Scrollen mitlaufende Leiste mit Abstand zur App-Leiste.
   * Das Wurzelelement selbst ist "sticky" (klebt innerhalb des umgebenden Containers). Beim Scrollen wird
   * geprüft, ob die Leiste ihre Klebeposition erreicht hat – erst dann erscheint der Schatten.
   */
  export default {
    beforeDestroy() {
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('resize', this.onScroll)
    },
    data: () => ({
      frame: null,
      stuck: false
    }),
    methods: {
      onScroll() {
        if (this.frame != null) {
          return
        }

        this.frame = window.requestAnimationFrame(() => {
          this.frame = null

          const top = this.$el.getBoundingClientRect().top

          this.stuck = window.pageYOffset > 0 && top <= this.offset + 1
        })
      }
    },
    mounted() {
      window.addEventListener('scroll', this.onScroll, { passive: true })
      window.addEventListener('resize', this.onScroll, { passive: true })
      this.onScroll()
    },
    name: 'StickyBar',
    props: {
      // Abstand von oben, an dem die Leiste klebt (App-Leiste 64 px + 8 px Luft)
      offset: {
        default: 72,
        type: Number
      }
    }
  }
</script>
